// ** React Imports
import {useEffect, useRef, useState} from 'react';

import {
    Typography,
    Box,
    Grid,
    FormLabel,
    RadioGroup,
    Radio,
    FormControlLabel,
    MenuItem,
    ToggleButton,
    ToggleButtonGroup,
    Card,
    CardContent,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers-pro";
import { DateTimePicker } from '@mui/x-date-pickers-pro';

import CustomTextField from "../../../components/mui/text-field";
import Checkbox from "@mui/material/Checkbox";

const BillingInformation = ({
  // estTravelTime,
  // setEstTravelTime,
  billingFreq,
  recurringType,
  depositReq,
  setDepositReq,
  depositType,
  setDepositType,
  formatsBilling,
  setFormatsBilling,
  monthlyOptions,
  setMonthlyOptions,
  // occurrences, 
  // setOccurrences,
  cycleStartDate, 
  setCycleStartDate,
  intervalDaysInput, 
  setIntervalDaysInput,
  weekOfMonth, 
  setWeekOfMonth,
  quarter, 
  setQuarter,
  monthOfQuarter, 
  setMonthOfQuarter,
  // handleEstTravelTimeChange,
  handleBillingFreqChange,
  handleRecurringTypeChange,
  handledDepositReqChange,
  handleDepositTypeChange,
  handleFormatBilling,
  formatsBillingWeekly,
  setIsChanged,
  setBillingInfoChanged
}) => {

    const formValues = {
    // estTravelTime,
    billingFreq,
    recurringType,
    depositReq,
    depositType,
    formatsBilling,
    monthlyOptions,
    // occurrences,
    cycleStartDate: cycleStartDate?.toString(),
    intervalDaysInput,
    weekOfMonth,
    quarter,
    monthOfQuarter,
  };

  
  const serialized = JSON.stringify(formValues);

  // ref to skip first render
  const isFirst = useRef(true);
  // ref to hold last seen serialized
  const prev = useRef(serialized);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
    } else if (prev.current !== serialized) {
      setIsChanged(true);
      setBillingInfoChanged(true)
    }
    // update last seen
    prev.current = serialized;
  }, [serialized, setIsChanged]);

  const handleUnifiedBillingChange = (value) => {
    if (value === 'per day') {
      handleBillingFreqChange('per job');
      handleRecurringTypeChange(''); 
    } else if (value === 'weekly' || value === 'bi-weekly' || value === 'monthly' || value === 'quarterly' || value === 'interval') {
      handleBillingFreqChange('recurring');
      handleRecurringTypeChange(value);
    } else {
      handleBillingFreqChange(value);
    }
  };


  const getUnifiedBillingValue = () => {
    if (billingFreq === 'per job') {
      return 'per day';
    } else if (billingFreq === 'recurring') {
      return recurringType;
    } else {
      return billingFreq; // For any other cases
    }
  };

  const getBillingCycleDescription = () => {
    const currentValue = getUnifiedBillingValue();
    
    switch (currentValue) {
      case 'per day':
        return {
          title: 'DAILY',
          descMain: 'A new Billing Cycle will begin each day at 12:00AM and end on the same day at 11:59PM.',
          color: '#23A26D'
        };
    case "weekly":
  return {
    title: "WEEKLY",
    descMain:
      "A new Billing Cycle will begin on the selected day of the week at 12:00 AM and will end after one week at 11:59 PM.",
    descExampleTitle: "For example:",
    descExample:
      "A new Billing Cycle will begin each Monday at 12:00 AM and end each Sunday at 11:59 PM.",
    color: "#23A26D"
  };


       case "bi-weekly":
  return {
    title: "BI-WEEKLY",
    descMain:
      "A new Billing Cycle will begin on the selected day at 12:00 AM and will end after two weeks at 11:59 PM.",
    descExampleTitle: "For example:",
    descExample:
      "A new Billing Cycle will begin every other Monday at 12:00 AM and end every other Sunday at 11:59 PM. This is a 14-day Billing Cycle.",
    color: "#23A26D"
  };

      case 'monthly':
        return {
          title: 'MONTHLY',
          descMain: 'A new Billing Cycle will begin on the 1st day of every month at 12:00AM and end on the last day at 11:59PM. This is a Monthly Billing Cycle.',
          color:'#23A26D'
        };
      default:
        return {
          title: 'SELECT FREQUENCY',
          descMain: 'Please select a billing frequency to see cycle details.',
          color: '#6B7280'
        };
    }
  };

  const cycleInfo = getBillingCycleDescription();

      return (
        <Grid container spacing={5}>
          {/* Left Column - All Form Fields */}
          <Grid item xs={12} md={6}>
            {/* <Grid item xs={12} md={6.1}>
              <Box
                sx={{
                  border: "1px solid #DBDBDB",
                  borderRadius: 1,
                  p: 2,
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      value={estTravelTime}
                      color="success"
                      checked={estTravelTime}
                      onChange={handleEstTravelTimeChange}
                    />
                  }
                  label={
                    <>
                      <Typography variant="body1" color="text.primary">
                        Estimated Travel Time
                      </Typography>
                      <Typography variant="caption">
                        Check this if travel time needs to be estimated
                      </Typography>
                    </>
                  }
                />
              </Box>
            </Grid> */}
          {/* {estTravelTime && (
              <Grid item xs={12} md={6.1}>
                <CustomTextField
                  fullWidth
                  label="Estimated Time Travel"
                  placeholder="Estimated Time"
                  type="number"
                />
              </Grid>
            )} */}
          <Grid item xs={12}>
            <CustomTextField
              fullWidth
              select
              value={getUnifiedBillingValue()}
              label="Billing Frequency"
              onChange={(e) => handleUnifiedBillingChange(e.target.value)}
            >
              <MenuItem value="select" disabled>
                Select
              </MenuItem>
              <MenuItem value="per day">Daily</MenuItem>
              <MenuItem value="weekly">Weekly</MenuItem>
              <MenuItem value="bi-weekly">Bi-Weekly</MenuItem>
              <MenuItem value="monthly">Monthly</MenuItem>
              {/* <MenuItem value="quarterly">Quarterly</MenuItem>
              <MenuItem value="interval">Interval Based</MenuItem> */}
            </CustomTextField>
          </Grid>
          
          {/* All the existing recurring logic remains exactly the same */}
          {billingFreq === "recurring" && (
            <>
              {recurringType === "weekly" && (
                <>
                  <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <Box>
                      <FormLabel
                        sx={{
                          fontSize: "13px",
                          color: "text.primary",
                          fontWeight: 400,
                          marginBottom: "4px",
                        }}
                      >
                        Day of Week
                      </FormLabel>
                    </Box>
                    <ToggleButtonGroup
                      value={formatsBilling}
                      exclusive
                      onChange={(e, newFormats) =>
                        handleFormatBilling(e, newFormats, "weekly")
                      }
                      aria-label="text alignment"
                      sx={{
                        flexWrap: { xs: "wrap", sm: "nowrap" }, // break only on mobile
                        gap: { xs: 1, sm: 0 }, // spacing only on mobile
                      }}
                    >
                      <ToggleButton value="mon" color="info" aria-label="mon">
                        Mon
                      </ToggleButton>
                      <ToggleButton value="tue" color="info" aria-label="tue">
                        Tue
                      </ToggleButton>
                      <ToggleButton value="wed" color="info" aria-label="wed">
                        Wed
                      </ToggleButton>
                      <ToggleButton
                        value="thurs"
                        color="info"
                        aria-label="thurs"
                      >
                        Thu
                      </ToggleButton>
                      <ToggleButton value="fri" color="info" aria-label="fri">
                        Fri
                      </ToggleButton>
                      <ToggleButton
                        // disabled
                        value="sat"
                        color="info"
                        aria-label="sat"
                      >
                        Sat
                      </ToggleButton>
                      <ToggleButton
                        // disabled
                        value="sun"
                        color="info"
                        aria-label="sun"
                      >
                        Sun
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Grid>
                  {/* <Grid item xs={12} sm={6.1}>
                    <CustomTextField
                      fullWidth
                      label="Occurrences"
                      type="number"
                      value={occurrences}
                      onChange={e => setOccurrences(+e.target.value)}
                    />
                    </Grid> */}
                  {/* <Grid item xs={12} sm={6.1}>
                      <FormLabel
                        sx={{
                          fontWeight: 400,
                          fontSize: "13px",
                          marginBottom: "4px",
                          color: "text.primary",
                          height: "100%",
                        }}
                      >
                        First Occurence Date (Optional) */}
                  {/* </FormLabel>
                      <LocalizationProvider dateAdapter={AdapterDayjs}> */}
                  {/* <DatePicker
                          sx={{ width: "100%" }}
                          slotProps={{ textField: { size: "small" } }}
                        /> */}
                  {/* <DatePicker
                          value={cycleStartDate}
                          onChange={newVal => setCycleStartDate(newVal)}
                          slotProps={{ textField: { size: "small" } }}
                          sx={{ width: "100%" }}
                        />
                      </LocalizationProvider>
                    </Grid> */}
                  {/* <Grid item xs={12} md={6.1}>
                      <FormControlLabel
                        control={<Checkbox color="success" />}
                        label="Exclude Holidays"
                      />
                    </Grid> */}
                </>
              )}
              {recurringType === "bi-weekly" && (
                <>
                  <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <FormLabel
                      sx={{
                        fontWeight: 400,
                        fontSize: "13px",
                        marginBottom: "4px",
                        color: "text.primary",
                        height: "100%",
                      }}
                    >
                      First Occurence Date
                    </FormLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        sx={{ width: "100%" }}
                        slotProps={{ textField: { size: "small" } }}
                        value={cycleStartDate}
                        onChange={(newVal) => setCycleStartDate(newVal)}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <Box>
                      <FormLabel
                        sx={{
                          fontSize: "13px",
                          color: "text.primary",
                          fontWeight: 400,
                          marginBottom: "4px",
                        }}
                      >
                        Day of Week
                      </FormLabel>
                    </Box>
                    <ToggleButtonGroup
                      value={formatsBilling}
                      exclusive
                      onChange={(e, newFormats) =>
                        handleFormatBilling(e, newFormats, "bi-weekly")
                      }
                      aria-label="text alignment"
                      sx={{
                        flexWrap: { xs: "wrap", sm: "nowrap" }, // break only on mobile
                        gap: { xs: 1, sm: 0 }, // spacing only on mobile
                      }}
                    >
                      <ToggleButton value="mon" color="info" aria-label="mon">
                        Mon
                      </ToggleButton>
                      <ToggleButton value="tue" color="info" aria-label="tue">
                        Tue
                      </ToggleButton>
                      <ToggleButton value="wed" color="info" aria-label="wed">
                        Wed
                      </ToggleButton>
                      <ToggleButton
                        value="thurs"
                        color="info"
                        aria-label="thurs"
                      >
                        Thu
                      </ToggleButton>
                      <ToggleButton value="fri" color="info" aria-label="fri">
                        Fri
                      </ToggleButton>
                      <ToggleButton
                        // disabled
                        value="sat"
                        color="info"
                        aria-label="sat"
                      >
                        Sat
                      </ToggleButton>
                      <ToggleButton
                        // disabled
                        value="sun"
                        color="info"
                        aria-label="sun"
                      >
                        Sun
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Grid>
                  {/* <Grid item xs={12} md={6.1}>
                      <FormLabel
                        sx={{
                          color: "rgba(47, 43, 61, 0.78)!important",
                          marginBottom: "4px",
                          fontSize: "13px",
                        }}
                      >
                        Final Invoice
                      </FormLabel>
                      <RadioGroup row name="finalInvoice">
                        <FormControlLabel
                          value="allJobsCompleted"
                          control={<Radio color="success" />}
                          label="When All Jobs Are Completed"
                        />
                        <FormControlLabel
                          value="endDate"
                          control={<Radio color="success" />}
                          label="End Date"
                        />
                      </RadioGroup>
                    </Grid> */}
                  <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {/* <FormControlLabel
                          control={<Checkbox color="success" />}
                          label="Exclude Weekends"
                        /> */}
                      {/* <FormControlLabel
                          control={<Checkbox color="success" />}
                          label="Exclude Holidays"
                        /> */}
                    </Box>
                  </Grid>
                </>
              )}
              {recurringType === "monthly" && (
                <>
                  {/* <Grid item xs={12} md={6.1}>
                      <FormLabel
                        sx={{
                          color: "rgba(47, 43, 61, 0.78)!important",
                          marginBottom: "4px",
                          fontSize: "13px",
                        }}
                      >
                        Monthly Options
                      </FormLabel>
                      <RadioGroup
                        row
                        name="monthlyOptions"
                        value={monthlyOptions}
                      >
                        <FormControlLabel
                          value="billingDay"
                          control={<Radio color="success" />}
                          label="Billing Day Of The Month"
                          onChange={(e) => setMonthlyOptions(e.target.value)}
                        />
                        <FormControlLabel
                          value="weekOfMonth"
                          control={<Radio color="success" />}
                          label="Week Of The Month"
                          onChange={(e) => setMonthlyOptions(e.target.value)}
                        />
                      </RadioGroup>
                    </Grid> */}
                  {monthlyOptions === "weekOfMonth" && (
                    // <>
                    //   <Grid item xs={12} md={6.1}>
                    //     <Box>
                    //       <FormLabel
                    //         sx={{
                    //           fontSize: "13px",
                    //           color: "text.primary",
                    //           fontWeight: 400,
                    //           marginBottom: "4px",
                    //         }}
                    //       >
                    //         Week of Month
                    //       </FormLabel>
                    //     </Box>
                    //     {/* <ToggleButtonGroup
                    //       value={formatsBilling}
                    //       onChange={handleFormatBilling}
                    //       aria-label="text alignment"
                    //     > */}
                    //     <ToggleButtonGroup
                    //       value={weekOfMonth}
                    //       exclusive
                    //       onChange={(event, v) => {
                    //         setWeekOfMonth(v)
                    //       }}
                    //     >
                    //       <ToggleButton value="first" color="info">
                    //         1st
                    //       </ToggleButton>
                    //       <ToggleButton value="second" color="info">
                    //         2nd
                    //       </ToggleButton>
                    //       <ToggleButton value="third" color="info">
                    //         3rd
                    //       </ToggleButton>
                    //       <ToggleButton value="fourth" color="info">
                    //         4th
                    //       </ToggleButton>
                    //     </ToggleButtonGroup>
                    //   </Grid>
                    //   <Grid item xs={12} md={6.1}>
                    //     <Box>
                    //       <FormLabel
                    //         sx={{
                    //           fontSize: "13px",
                    //           color: "text.primary",
                    //           fontWeight: 400,
                    //           marginBottom: "4px",
                    //         }}
                    //       >
                    //         Day of Week
                    //       </FormLabel>
                    //     </Box>
                    //     <ToggleButtonGroup
                    //       value={formatsBilling}
                    //       onChange={handleFormatBilling}
                    //       aria-label="text alignment"
                    //     >
                    //       <ToggleButton
                    //         value="mon"
                    //         color="info"
                    //         aria-label="mon"
                    //       >
                    //         Mon
                    //       </ToggleButton>
                    //       <ToggleButton
                    //         value="tue"
                    //         color="info"
                    //         aria-label="tue"
                    //       >
                    //         Tue
                    //       </ToggleButton>
                    //       <ToggleButton
                    //         value="wed"
                    //         color="info"
                    //         aria-label="wed"
                    //       >
                    //         Wed
                    //       </ToggleButton>
                    //       <ToggleButton
                    //         value="thurs"
                    //         color="info"
                    //         aria-label="thurs"
                    //       >
                    //         Thu
                    //       </ToggleButton>
                    //       <ToggleButton
                    //         value="fri"
                    //         color="info"
                    //         aria-label="fri"
                    //       >
                    //         Fri
                    //       </ToggleButton>
                    //       <ToggleButton
                    //         disabled
                    //         value="sat"
                    //         color="info"
                    //         aria-label="sat"
                    //       >
                    //         Sat
                    //       </ToggleButton>
                    //       <ToggleButton
                    //         disabled
                    //         value="sun"
                    //         color="info"
                    //         aria-label="sun"
                    //       >
                    //         Sun
                    //       </ToggleButton>
                    //     </ToggleButtonGroup>
                    //   </Grid>
                    // </>
                    <></>
                  )}

                  {/* <Grid item xs={12} sm={6.1}>
                      <FormLabel
                        sx={{
                          fontWeight: 400,
                          fontSize: "13px",
                          marginBottom: "4px",
                          color: "text.primary",
                          height: "100%",
                        }}
                      >
                        Day Selector
                      </FormLabel>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          sx={{ width: "100%" }}
                          slotProps={{ textField: { size: "small" } }}
                        />
                      </LocalizationProvider>
                    </Grid> */}
                  {/* <Grid item xs={12} md={6.1}>
                    <CustomTextField
                      fullWidth
                      label="Occurrences"
                      type="number"
                      value={occurrences}
                      onChange={e => setOccurrences(+e.target.value)}
                    />
                    </Grid> */}
                  <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {/* <FormControlLabel
                          control={<Checkbox color="success" />}
                          label="Exclude Weekends"
                        /> */}
                      {/* <FormControlLabel
                          control={<Checkbox color="success" />}
                          label="Exclude Holidays"
                        /> */}
                    </Box>
                  </Grid>
                </>
              )}
              {recurringType === "quarterly" && (
                <>
                  <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <FormLabel
                      sx={{
                        fontWeight: 400,
                        fontSize: "13px",
                        marginBottom: "4px",
                        color: "text.primary",
                        height: "100%",
                      }}
                    >
                      First Occurence Date
                    </FormLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        sx={{ width: "100%" }}
                        slotProps={{ textField: { size: "small" } }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <CustomTextField
                      select
                      label="Quarter"
                      value={quarter}
                      onChange={(e) => setQuarter(e.target.value)}
                    >
                      <MenuItem value="Q1">First Quarter (Jan-Mar)</MenuItem>
                      <MenuItem value="Q2">Second Quarter (Apr-Jun)</MenuItem>
                      <MenuItem value="Q3">Third Quarter (Jul-Sep)</MenuItem>
                      <MenuItem value="Q4">Fourth Quarter (Oct-Dec)</MenuItem>
                    </CustomTextField>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: '20px' }}>
                    {/* <CustomTextField
                        fullWidth
                        select
                        label="Month of Quarter"
                        defaultValue="1"
                      > */}
                    <CustomTextField
                      select
                      label="Month of Quarter"
                      value={monthOfQuarter}
                      onChange={(e) => setMonthOfQuarter(+e.target.value)}
                    >
                      <MenuItem value="1">First Month</MenuItem>
                      <MenuItem value="2">Second Month</MenuItem>
                      <MenuItem value="3">Third Month</MenuItem>
                      <MenuItem value="4">Fourth Month</MenuItem>
                    </CustomTextField>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {/* <FormControlLabel
                          control={<Checkbox color="success" />}
                          label="Exclude Weekends"
                        /> */}
                      {/* <FormControlLabel
                          control={<Checkbox color="success" />}
                          label="Exclude Holidays"
                        /> */}
                    </Box>
                  </Grid>
                </>
              )}
              {recurringType === "interval" && (
                <>
                  <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <CustomTextField
                      fullWidth
                      label="Interval (Days)"
                      type="number"
                      value={intervalDaysInput}
                      onChange={(e) => setIntervalDaysInput(+e.target.value)}
                    />
                  </Grid>
                  {/* <Grid item xs={12} md={6.1}>
                    <CustomTextField
                      fullWidth
                      label="Occurrences"
                      type="number"
                      value={occurrences}
                      onChange={e => setOccurrences(+e.target.value)}
                    />
                    </Grid> */}
                  <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <FormLabel
                      sx={{
                        fontWeight: 400,
                        fontSize: "13px",
                        marginBottom: "4px",
                        color: "text.primary",
                        height: "100%",
                      }}
                    >
                      First Occurence Date
                    </FormLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        sx={{ width: "100%" }}
                        slotProps={{ textField: { size: "small" } }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <FormLabel
                      sx={{
                        color: "rgba(47, 43, 61, 0.78)!important",
                        marginBottom: "4px",
                        fontSize: "13px",
                      }}
                    >
                      Final Voice
                    </FormLabel>
                    <RadioGroup row name="monthlyOptions">
                      <FormControlLabel
                        value="allJobsCompleted"
                        control={<Radio color="success" />}
                        label="When All Jobs Are Completed"
                      />
                      <FormControlLabel
                        value="endDate"
                        control={<Radio color="success" />}
                        label="End Date"
                      />
                    </RadioGroup>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {/* <FormControlLabel
                          control={<Checkbox color="success" />}
                          label="Exclude Weekends"
                        /> */}
                      {/* <FormControlLabel
                          control={<Checkbox color="success" />}
                          label="Exclude Holidays"
                        /> */}
                    </Box>
                  </Grid>
                </>
              )}
            </>
          )}
          {/* <Grid item xs={12} md={6.1}>
              <Box
                sx={{
                  border: "1px solid #DBDBDB",
                  borderRadius: 1,
                  p: 2,
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      value={depositReq}
                      color="success"
                      checked={depositReq}
                      onChange={handledDepositReqChange}
                    />
                  }
                  label={
                    <>
                      <Typography variant="body1" color="text.primary">
                        Deposit Required
                      </Typography>
                      <Typography variant="caption">
                        Check this if a deposit is required
                      </Typography>
                    </>
                  }
                />
              </Box>
            </Grid> */}
          {depositReq && (
            <Grid item xs={12} style={{ marginTop: '20px' }}>
              <FormLabel
                required
                sx={{
                  color: "rgba(47, 43, 61, 0.78)!important",
                  "& .MuiFormLabel-asterisk": {
                    color: "error.main",
                  },
                  marginBottom: "4px",
                  fontSize: "13px",
                }}
              >
                Deposit Type
              </FormLabel>
              <RadioGroup
                row
                name="depositType"
                value={depositType}
                onChange={(e) => handleDepositTypeChange(e.target.value)}
              >
                <FormControlLabel
                  value="percentage"
                  control={<Radio color="success" />}
                  label="Percentage"
                />
                <FormControlLabel
                  value="amount"
                  control={<Radio color="success" />}
                  label="Amount"
                />
              </RadioGroup>
              <CustomTextField
                fullWidth
                placeholder={`Enter deposit ${depositType}`}
              />
            </Grid>
          )}
          </Grid>

          {/* Right Column - Info Card */}
        <Grid item xs={12} md={6}>
  <Box sx={{ maxWidth: 350, width: "100%", }}>
    <Card
      sx={{
        border: `1px solid ${cycleInfo.color}20`,
        backgroundColor: `${cycleInfo.color}08`,
        borderRadius: 2,
        height: "fit-content",
        transition: "all 0.3s ease",
        "&:hover": {
          boxShadow: `0 4px 12px ${cycleInfo.color}20`,
        },
        position: "sticky",
        top: "20px",
      }}
    >
              <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    color: cycleInfo.color,
                    fontWeight: 600,
                    mb: 2,
                    fontSize: '1rem'
                  }}
                >
                  {cycleInfo.title}
                </Typography>
               <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            lineHeight: 1.6,
            fontSize: "0.875rem",
            mb: 2
          }}
        >
          {cycleInfo.descMain}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            lineHeight: 1.6,
            fontSize: "0.875rem",
            fontWeight: 600,
            mb: 1
          }}
        >
          {cycleInfo.descExampleTitle}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            lineHeight: 1.6,
            fontSize: "0.875rem"
          }}
        >
          {cycleInfo.descExample}
        </Typography>
      </CardContent>
  </Card>
          </Box>
        </Grid>
        </Grid>
      );
}

export default BillingInformation;